export default __webpack_public_path__ + "static/media/birthdayCharacter.ee43f3be.png";